"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _default = () => {
  const callbacks = [];
  let destroyed = false;
  return {
    destroy() {
      destroyed = true;
      callbacks.forEach(callback => {
        callback();
      });
    },

    onDestroy(callback) {
      destroyed ? callback() : callbacks.push(callback);
    }

  };
};

exports.default = _default;
module.exports = exports.default;